<template>
  <v-row align-content="center" justify="start">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn
          color="green"
          size="x-small"
          variant="plain"
          append-icon="mdi-plus"
          v-bind="props"
          >Adicionar Nova Área de Concentração</v-btn
        >
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Adicionar Área de Concentração</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" validate-on="lazy submit">
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="this.descricao"
                    required
                    label="Descrição*"
                    placeholder="Descrição da funcionalidade que será testada"
                    rows="3"
                    :rules="descricaoRules"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue-darken-1" variant="text" @click="submitForm">
            Salvar
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;

/**
 * @module CreateAreaConcentracao
 * @desc Modal de criação da area de concentração
 * @vue-data {boolean} [dialog=false] - Flag que indica se o diálogo
 * está aberto ou fechado.
 * @vue-data {string} [descricao=null] - Recebe a descrição da area.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se a área de
 * concentração ainda está sendo criada.
 */
export default {
  props: {
    id: Number,
  },
  emits: ['areaConcentracaoAdicionada'],
  data: () => ({
    dialog: false,
    descricao: '',
    isLoading: false,
    descricaoRules: [
      (v) => !!v || 'Descrição é obrigatória',
      (v) =>
        (v && v.length <= 200) || 'Descrição deve ter no máximo 200 caracteres',
    ],
  }),
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Envia o formulário.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        const data = {
          descricao: this.descricao,
          // eslint-disable-next-line camelcase
          fl_realizada: false,
          // eslint-disable-next-line camelcase
          id_charter: Number(this.id),
        };

        try {
          this.isLoading = true;
          const response = await axios.post(
            `${apiUrl}/api/v1/areaConcentracao/`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          const idProjeto = this.$route.params.idProjeto;

          this.$toast.success(response.data.msg);
          this.$emit('areaConcentracaoAdicionada', this.id);
          this.$router.push(`/projects/${idProjeto}/Charters/${this.id}`);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
          this.descricao = '';
        }
      }
    },
  },
};
</script>
